require('./bootstrap');

$(window).on('resize', function() {
    pinFooter();
});

$(function() {
    pinFooter();

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Menu
    $('.mobile-nav').on('click', function(e) {
        e.preventDefault();
        $(this).add('header nav').toggleClass('active');
        $('.overlay').toggleClass('mobile-nav');
    });

    $('header nav button').on('click', function() {
        $(this).toggleClass('active');
        $(this).next('ul').slideToggle();
    });

    // Search
    $('.search, #search .close').on('click', function() {
        $('#search').toggleClass('active');
    });

    // Animated Labels
    let $animLabels = '.animated-label :input:not([type="button"])';
    $($animLabels).each(function() {
        if ($.trim($(this).val())) {
            $(this).parents('.animated-label').addClass('focused');
        }
    });

    $(document).on('focus', $animLabels, function() {
        $(this).parents('.animated-label').addClass('focused');
    });

    $(document).on('blur', $animLabels, function() {
        if (! $.trim($(this).val())) {
            $(this).parents('.animated-label').removeClass('focused');
        }
    });

    // Error messages
    $('span.error:not(:empty)').each(function () {
        $(this).siblings('label, :input, .selectize-control').addClass('error');
    });

    checkRequired();
    checkReadonly();

    // Button Toggles
    $('.button-toggle button').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
    });

    // Modals
    $('.modal .close').on('click', function() {
        $('.modal, .overlay').removeClass('active');
    });

    // Instagram
    if ($('#instafeed').length > 0) {
        $.getJSON('https://ig.instant-tokens.com/users/cf3da3fe-9eaf-4bf0-a1f1-438c68ba8066/instagram/17841413101167654/token?userSecret=2frh182oim2dpi0ied1s47', function(data) {
            var feed = new Instafeed({
                accessToken: data.Token,
                limit: 4,
                templateBoundaries: ['{#', '#}'],
                template: '<a href="{#link#}" target="_blank" class="insta-tag" style="background-image: url({#image#});"><div class="rollover"><i class="fab fa-instagram"></i>@Remunerator</div></a>',
                transform: function(item) {
                    var d = new Date(item.timestamp);
                    item.date = [d.getDate(), d.getMonth(), d.getYear()].join('/');
                    return item;
                }
            });
            feed.run();
        });
    }

    // Testimonials
    $('#testimonials .testimonials').slick({
        dots: false,
        arrows: true,
        nextArrow: $('#testimonials .next'),
        prevArrow: $('#testimonials .prev')
    });

    // Forms
    $('.flatpickr:not([disabled], [readonly])').each(function() {
        let $allowInput = $(this).data('allow-input') || null,
            $minDate = $(this).data('min-date') ? $(this).data('min-date') : null,
            $maxDate = $(this).data('max-date') ? $(this).data('max-date') : null;

        flatpickr($(this)[0], {
            dateFormat: 'd/m/Y',
            minDate: $minDate,
            maxDate: $maxDate,
            allowInput: $allowInput,
            monthSelectorType: 'static',
            disableMobile: true
        });
    });

    $('.optional.row, .optional.cols-1, .optional.cols-2, .optional.cols-3, .optional.cols-4').css('display', 'flex').hide();

    $('select[data-optional]').on('change', function() {
        let $id = $(this).attr('id'),
            $val = $(this).val() || null,
            $opts = $(this).data('optional');

        hideOptional($id, $opts);

        if ($val && $opts.includes($val)) {
            $('.' + $id + '-' + $val.toLowerCase().replace(' ', '-')).fadeIn();
        }
    }).trigger('change');

    function hideOptional($id, $opts) {
        for (let i = 0; i < $opts.length; i++) {
            let $opt = $opts[i].toLowerCase(),
                $children = $('.' + $id + '-' + $opt + ' select[data-optional]');

            $('.' + $id + '-' + $opt).fadeOut();
            // Reset all releveant optional fields
            // $('.' + $id + '-' + $opt + ' :input').each(function() {
            //     $(this).val('').trigger('blur');
            //     if ($(this).hasClass('selectize')) {
            //         window[$(this).attr('id') + '_selectize'].clear();
            //     }
            // });

            if ($children.length) {
                $.each($children, function() {
                    let $childId = $(this).attr('id'),
                        $childOpts = $(this).data('optional');
                    hideOptional($childId, $childOpts);
                });
            }
        }
    }

    showHidePostalAddress();

    $('input#same_as_residential').on('change', function() {
        showHidePostalAddress();
    });

    // Prevent pasting into fields: e.g. confirm_email
    $('.nopaste').on('paste', function (e) {
        e.preventDefault();
    });

    // Don't follow disabled links
    $('a[disabled]').on('click', function (e) {
        e.preventDefault();
    });

    // Add History
    $(document).on('blur', '.years, .months', function () {
        let $years = $months = $total = 0;

        $('.years').each(function () {
            $years += parseInt($(this).val()) || 0;
        });

        $('.months').each(function () {
            $months += parseInt($(this).val()) || 0;
        });

        $total = ($years * 12) + $months;

        if ($total > 0 && $total < 36) {
            $('.add-history').show();
        } else {
            $('.add-history').hide();
        }
    });

    $('.years, .months').trigger('blur');

    $('.add-history').on('click', function () {
        let $type = $(this).data('type'),
            $i = ($('.' + $type).last().data('count') + 1) || 0,
            $template = $('#' + $type + '-template').html().replace(/{i}/g, $i);

        $('.' + $type + '-container').append($template).show().find('.history:last-child :input:visible').first().trigger('focus');
        $(this).hide();

        checkRequired();
        checkReadonly();
        initializeSelectize();
    });

    $(document).on('click', '.delete-repeatable', function () {
        let $tar = '.' + $(this).data('target');
        $(this).closest($tar).remove();
    });

    // Add .active to current URL
    $('a[href="' + window.location.href + '"]').addClass('active');

    // Replace CSS hover with JS for iOS interactions
    $('.info-hover').on('touchend', function() {
        $(this).toggleClass('active');
    }).on('mouseover', function() {
        $(this).addClass('active');
    }).on('mouseout', function() {
        $(this).removeClass('active');
    });

    // Sliders
    var slideWrapper = $('.main-slider'),
        iframes = slideWrapper.find('.embed-player'),
        lazyImages = slideWrapper.find('.slide-image'),
        lazyCounter = 0;

    // Initialize
    slideWrapper.on('init', function(slick) {
        slick = $(slick.currentTarget);
        setTimeout(function() {
            playPauseVideo(slick, 'play');
        }, 1000);
        resizePlayer(iframes, 16 / 9);
    });

    slideWrapper.on('beforeChange', function(event, slick) {
        slick = $(slick.$slider);
        playPauseVideo(slick, 'pause');
    });

    slideWrapper.on('afterChange', function(event, slick) {
        slick = $(slick.$slider);
        playPauseVideo(slick, 'play');
    });

    slideWrapper.on('lazyLoaded', function(event, slick, image, imageSource) {
        lazyCounter++;
        if (lazyCounter === lazyImages.length) {
        lazyImages.addClass('show');
        // slideWrapper.slick('slickPlay');
        }
    });

    // Start the Slider
    slideWrapper.slick({
        fade: true,
        autoplaySpeed: 4000,
        autoplay: true,
        lazyLoad: 'progressive',
        speed: 1000,
        arrows: false,
        dots: true,
        cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)'
    });

    // Resize Event
    $(window).on('resize.slickVideoPlayer', function() {
      resizePlayer(iframes, 16 / 9);
    });

    // Positive message timeout
    setTimeout(function() {
        $('.message.positive').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 5000);

    // Accordions
    if ($('.toggle .toggle-title.active').length > 0) {
        $('.toggle .toggle-title.active').next('.toggle-inner').slideToggle(250);
    }

    $('.toggle .toggle-title').on('click', function() {
        $(this).toggleClass('active').next('.toggle-inner').slideToggle(250);
    });

    // Galleries
    $('.gallery').lightGallery({
        selector: 'figure',
        subHtmlSelectorRelative: true
    });

    // Default Slick Slider
    $('.default-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000
    });

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function() {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    // Selectize
    initializeSelectize();
});

window.initializeSelectize = function () {
    $('select.selectize').each(function() {
        var create = false;
        var delimiter = ',';
        var persist = false;
        var openOnFocus = true;
        var sortField = '$order';

        // TODO Change parameters to data-attributes
        if ($(this).hasClass('create')) {
            create = true;
        }

        if ($(this).hasClass('sort-index')) {
            sortField = [{
                field: 'index',
                direction: 'desc'
            }, {
                field: '$score'
            }];
        }

        if (create) {
            openOnFocus = false;
            var createUrl = $(this).data('create-url');
            create = function(input) {
                $.ajax({
                    'type': 'post',
                    'url': createUrl,
                    'async': false,
                    'data': {
                        text: input
                    }
                }).done(function(response) {
                    if (response.status === 201) {
                        id = response.id;
                    } else {
                        console.log('ajaxerror', response);
                    }
                }).fail(function(response) {
                    console.log('ajaxerror', response);
                }).always(function(response) {
                    console.log('ajaxalways', response);
                });

                return {
                    value: id,
                    text: input
                };
            }
        }

        let $select = $(this).selectize({
            delimiter: delimiter,
            persist: persist,
            create: create,
            sortField: sortField,
            openOnFocus: openOnFocus,
            onChange: function (val) {
                let $id = $(this)[0].$input[0].id;
                if (val && $('#' + $id).parents('.animated-label').length > 0) {
                    $('#' + $id).parents('.animated-label').addClass('focused').find('select').valid();
                }
            },
            onFocus: function () {
                let $id = $(this)[0].$input[0].id;
                $('#' + $id).parents('.animated-label').addClass('focused');
            },
            onBlur: function () {
                let $id = $(this)[0].$input[0].id;
                if ($('#' + $id).val()) {
                    setTimeout(function () {
                        $('#' + $id).parents('.animated-label').addClass('focused');
                    }, 10);
                } else {
                    $('#' + $id).parents('.animated-label').removeClass('focused');
                }
            }
        });

        window[$(this).attr('id') + '_selectize'] = $select[0].selectize;
    });
};

function pinFooter() {
    let $contentHeight = 0;

    // Don't include the header, as the .page-header accounts for this
    // if ($('header').length) {
    //     $contentHeight += $('header').outerHeight(true);
    // }

    if ($('footer').length) {
        $contentHeight += $('footer').outerHeight(true);
    }

    if ($('.page-header').length) {
        $contentHeight += $('.page-header').outerHeight(true);
    }

    // Dynamically calculate the height for all visible siblings
    // $('main').siblings(':visible').each(function() {
    //     if ($(this).css('opacity') > 0) {
    //         $contentHeight += $(this).outerHeight(true);
    //     }
    // });

    $('main').css('min-height', 'calc(100vh - ' + $contentHeight + 'px)');
}

function showHidePostalAddress() {
    if ($('input#same_as_residential').is(':checked')) {
        $('.postal-address').slideUp();
    } else {
        $('.postal-address').slideDown();
    }
}

window.toggleElement = function (trigger, target) {
    if ($(trigger).is(':checked')) {
        $(target).slideDown();
    } else {
        $(target).slideUp();
    }
}

window.checkRequired = function () {
    $(':input[required]').each(function () {
        $(this).siblings('label').addClass('required');
    });
}

window.checkReadonly = function () {
    $(':input[readonly]').each(function () {
        $(this).siblings('label').addClass('readonly');
    });
}

window.checkSelected = function () {
    $('select > [selected]').each(function () {
        $(this).closest('.animated-label').addClass('focused');
    });
}

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), '*');
}

// When the slide is changing
function playPauseVideo(slick, control) {
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find('.slick-current');
    slideType = currentSlide.attr('class').split(' ')[1];
    player = currentSlide.find('iframe').get(0);
    startTime = currentSlide.data('video-start');

    if (slideType === 'vimeo') {
        switch (control) {
            case 'play':
                if ((startTime != null && startTime > 0) && ! currentSlide.hasClass('started')) {
                    currentSlide.addClass('started');
                    postMessageToPlayer(player, {
                        'method': 'setCurrentTime',
                        'value': startTime
                    });
                }
                postMessageToPlayer(player, {
                    'method': 'play',
                    'value': 1
                });
            break;
            case 'pause':
                postMessageToPlayer(player, {
                    'method': 'pause',
                    'value': 1
                });
            break;
        }
    } else if (slideType === 'youtube') {
        switch (control) {
            case 'play':
                postMessageToPlayer(player, {
                    'event': 'command',
                    'func': 'mute'
                });
                postMessageToPlayer(player, {
                    'event': 'command',
                    'func': 'playVideo'
                });
            break;
            case 'pause':
                postMessageToPlayer(player, {
                    'event': 'command',
                    'func': 'pauseVideo'
                });
            break;
        }
    } else if (slideType === 'video') {
        video = currentSlide.children('video').get(0);
        if (video != null) {
            if (control === 'play') {
                video.play();
            } else {
                video.pause();
            }
        }
    }
}

// Resize player
function resizePlayer(iframes, ratio) {
    if (! iframes[0]) return;
    var win = $('.main-slider'),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16 / 9;

    iframes.each(function() {
        var current = $(this);
        if (width / ratio < height) {
            playerWidth = Math.ceil(height * ratio);
            current.width(playerWidth).height(height).css({
                left: (width - playerWidth) / 2,
                top: 0
            });
        } else {
            playerHeight = Math.ceil(width / ratio);
            current.width(width).height(playerHeight).css({
                left: 0,
                top: (height - playerHeight) / 2
            });
        }
    });
}

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
   return string.split(subString, index).join(subString).length;
}

$.validator.addMethod('length', function(value, element, param) {
    return this.optional( element ) || value.length == param;
}, 'Please enter a {0} digit number');

$.validator.addMethod('emailAddress', function(value, element) {
    re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return this.optional( element ) || re.test( value );
}, 'Please enter a valid email address');

$.validator.addMethod('numberSpace', function(value, element) {
    re = /^[\d\s]+$/;
    return this.optional( element ) || re.test( value );
}, 'Please enter numbers or spaces only');

$.validator.addMethod('minDOB', function(value, element) {
    var minDate = new Date();
    var inputDate = new Date(toDate(value));
    newYear = minDate.getFullYear() - 18;
    minDate.setFullYear(newYear);
    if (inputDate < minDate) {
        return true;
    }
    return false;
}, 'Must be at least 18 years old');

$.validator.addMethod('minEXP', function(value, element) {
    var minDate = new Date();
    var inputDate = new Date(toDate(value));
    if (inputDate < minDate) {
        return false;
    }
    return true;
}, 'Expiration must be in the future');

$.validator.addMethod('groupNotZero', function(value, element, param) {
    var $count = 0;
    $(param).each(function() {
        $count += $(this).val();
    });
    return this.optional( element ) || $count > 0;
}, 'Both Years and Months cannot be 0');

$.validator.addMethod('alphanumericstrict', function(value, element) {
    return this.optional(element) || /^[a-zA-Z0-9]+$/.test(value);
}, 'Please enter numbers or letters only');

$.validator.addMethod('exactlength', function(value, element, param) {
    return this.optional(element) || value.length == param;
}, 'Please enter exactly {0} characters');

$.validator.addMethod('twoDecimalPlaces', function (value, element) {
    return this.optional(element) || /(?!0,?\d)([0-9]{0,}(\.[0-9]{2}))$/.test(value);
}, 'Please enter a value in the format 0.00');

$.validator.addMethod('yearsMonths', function(value, element) {
    let $el = $(element),
        $tar = '#' + $el.attr('id');

    if ($el.hasClass('years')) {
        $tar = $tar.replace('years', 'months');
    } else {
        $tar = $tar.replace('months', 'years');
    }

    return ($el.val() || $($tar).val());
}, 'Please enter a value for Years and / or Months');

$.validator.addMethod('timeAt', function (value, element, options) {
	var $fields = $(options[2], element.form),
		$fieldsFirst = $fields.eq(0),
		validator = $fieldsFirst.data('valid_time_at') ? $fieldsFirst.data('valid_time_at') : $.extend({}, this),
        $total = 0,
        $years = $('.years').each(function () {
            $total += parseInt($(this).val() * 12) || 0;
        }),
        $months = $('.months').each(function () {
            $total += parseInt($(this).val()) || 0;
        }),
		isValid = $total >= options[1];

	$fieldsFirst.data('valid_time_at', validator);

	if (! $(element).data('being_validated')) {
		$fields.data('being_validated', true);
		$fields.each(function () {
			validator.element(this);
		});
		$fields.data('being_validated', false);
	}
	return isValid;
}, $.validator.format('Please provide a minimum of {1} months {0} history.'));

$.validator.addClassRules({
    'required-select': {
        required: {
            depends: function (element) {
                return $('#save').val() === 1;
            }
        }
    },
    'years': {
        yearsMonths: true
    },
    'months': {
        yearsMonths: true
    },
    'accessory-desc': {
        required: {
            depends: function (element) {
                return $(this).closest('.repeatable').find('.accessory-val').val();
            }
        }
    },
    'accessory-val': {
        required: {
            depends: function (element) {
                return $(this).closest('.repeatable').find('.accessory-desc').val();
            }
        }
    },
    'dollar-amount': {
        number: true,
        twoDecimalPlaces: true
    },
    'postcode': {
        exactlength: 4
    }
});

function toDate(dateStr) {
    var parts = dateStr.split('/');
    return new Date(parts[2], parts[1] - 1, parts[0]);
}

// Validation Defaults
jQuery.validator.setDefaults({
    errorElement: 'span',
    normalizer: function(value) {
        return $.trim(value);
    },
    errorPlacement: function(error, element) {
        if (element.attr('data-rule-require_from_group') && element.attr('type') == 'checkbox') {
            element.closest('.radiochecks').after(error);
        } else if (element.attr('type') == 'checkbox') {
            element.next('label').after(error);
        } else if (element.attr('type') == 'radio') {
            element.closest('.radiochecks').after(error);
        } else if (element.parents('.selectize').length) {
            element.closest('.selectize-control').after(error);
        } else if (element.hasClass('selectized')) {
            element.next('.selectize-control').after(error);
        } else {
            error.insertAfter(element);
        }
    },
    showErrors: function(errorMap, errorList) {
        this.defaultShowErrors();

        if ($('.tabs dt.active').length) {
            $('.tabs dt.active button').trigger('click');
        }
    },
    ignore: ':hidden:not(.selectized), :hidden > .selectized, .selectize-control .selectize-input input',
    submitHandler: function(form) {
        resetOptional(form);
        form.submit();
    }
});

window.resetOptional = function(form) {
    $(form).find('.optional :input:hidden').each(function() {
        $(this).val('');
    });
}
